<script setup>
import { ref } from "vue";
import { auth, db } from "../../../db.js";
import { EntityText } from "@comp";
import { londonIsoWeekKey } from "./week.mjs";

const text = ref("");
const editorKey = ref(0);
const submitting = ref(false);
const message = ref("");
const error = ref("");

async function submit() {
  error.value = "";
  message.value = "";
  const uid = auth.currentUser?.uid;
  const body = text.value.trim();
  if (!uid) {
    error.value = "Sign in before recording time.";
    return;
  }
  if (!body) {
    error.value = "Enter the hours and projects you worked this week.";
    return;
  }
  submitting.value = true;
  try {
    await db.set(`Timesheets/WeeklySubmissions/${londonIsoWeekKey()}/${uid}`, {
      text: body,
      status: "pending",
      submittedAt: Date.now(),
    });
    message.value = "Submitted. Hours will be added to the matching job cards.";
    text.value = "";
    editorKey.value += 1;
  } catch (err) {
    console.error(err);
    error.value = "Could not submit weekly time.";
  } finally {
    submitting.value = false;
  }
}
</script>

<template>
  <main class="w-full flex flex-col">
    <div class="m-2 p-2 bg-white rounded shadow flex flex-col">
      <h1 class="p-2 text-lg font-medium text-primary">Weekly time</h1>
      <p class="text-sm text-gray-600 px-2 mt-2 mb-4">
        Enter the hours and projects you worked this week. For example: I worked 6 hours on Job 001, and 24 hours on Job 002 and 12 hours on general admin.
        Select a suggested entity to link it, or leave the text as written.
      </p>
      <form @submit.prevent="submit">
        <EntityText
          :key="editorKey"
          v-model="text"
          label="Hours and projects"
          name="weeklyTime"
          :required="true"
          :disabled="submitting"
        />
        <button class="success ml-2" type="submit" :disabled="submitting">
          {{ submitting ? "Submitting" : "Submit" }}
        </button>
      </form>
      <p v-if="message" class="text-sm text-primary m-2">{{ message }}</p>
      <p v-if="error" class="text-sm text-red-700 m-2">{{ error }}</p>
    </div>
  </main>
</template>
